import { useEffect } from "react";
import useGetCategories from "../apiCalls/categories";
import useGetIntegrations from "../apiCalls/integrations";
import useGetAccounts from "../apiCalls/accounts";
import useGetCharts from "../apiCalls/charts";
import useGetSampleDataTables from "../apiCalls/sample-datatables";
import { useGetUsers } from "../apiCalls/users";
import useGetRoles from "../apiCalls/roles";
import useGetAccountDataTables from "../apiCalls/account-datatables";
import useGetDataTables from "../apiCalls/datatables";
import useGetSettings from "../apiCalls/settings";
import useGetAccountSettings from "../apiCalls/account-settings";
import useGetPermissions from "../apiCalls/permissions";
import useGetRolePermissions from "../apiCalls/rolepermissions";
import useGetDashPermissions from "../apiCalls/dashboardpermissions";
import { useGetDashboardUserSettings } from "../apiCalls/dashboardusersettings";
import { useAuthStore } from "../contexts/AuthContext";
import { useCubeDataDispatch } from "../contexts/CubeDataContext";
import useGetCubeMetaData  from "../apiCalls/cube-metadata";
import useGetMaintenanceTime from "../apiCalls/maintenance";
import useGetAccountCustomJoins  from "../apiCalls/account-custom-joins";

// build this component to import data that is global in the app (data that is the same and used regardless of what user you are or account you are in)
export default function AppDataLoader() {
    useGetAccounts();
    useGetUsers();
    useGetRoles();
    useGetAccountDataTables();
    useGetSampleDataTables();
    useGetCharts();
    useGetCategories();
    useGetIntegrations();
    useGetDataTables();
    useGetSettings();
    useGetPermissions();
    useGetDashPermissions();
    useGetAccountSettings();
    useGetRolePermissions();
    useGetDashboardUserSettings();
    useGetCubeMetaData();
    useGetMaintenanceTime();
    useGetAccountCustomJoins();

    const { selectedAccount } = useAuthStore()
    const cubeDataDispatch = useCubeDataDispatch();

    // Effect to remove liveCubeData when account changes
    useEffect(() => {
        cubeDataDispatch({
            type: "resetLiveTableData"
        })
    }, [selectedAccount, cubeDataDispatch])
}